export default function PHP_is_callable() {
  return (
    <div>
      <h1>PHP_is_callable</h1>
    </div>
  );
}
